// extracted by mini-css-extract-plugin
export default {"root":"SettingContainer_root__3rTBj"};